import React from 'react';

const FounderSection = ({toSection,section}) => {
  return (
    <div style={{marginTop: '-40px'}} id={section} className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#B8E1FF"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-white relative py-20">
        <div className="container mx-auto px-4 py-20">
          <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-[#002147] mb-12">
           A Word from Our Founder 
          </h2>
          
               <div className="max-w-6xl mx-auto relative">
            {/* 16:9 aspect ratio wrapper */}
            <div className="relative pt-[56.25%] rounded-xl overflow-hidden shadow-xl">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/-LAP1FnldTo"
                title="A Word from Our Founder"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#B8E1FF"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default FounderSection;